module.exports = __webpack_public_path__ + "2d6ed2ebcf907f6514685de0bcfe3ab6.jpg";